var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0a8.5 8.5 0 010 17h-3L0 20l1.64-6.48A8.5 8.5 0 018.5 0z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0iI2JlYmViZSI+CiAgICA8cGF0aCBkPSJNMTEuNSAwYTguNSA4LjUgMCAwMTAgMTdoLTNMMCAyMGwxLjY0LTYuNDhBOC41IDguNSAwIDAxOC41IDB6IiBmaWxsPSIjYmViZWJlIiAvPgo8L3N2Zz4K";
export { SvgChatBubble as ReactComponent };